module.exports = __webpack_public_path__ + "img/footer-fb.4b6ae7fc.png";